// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".callout.image-right>div:first-of-type{order:2;background-position:100%}#tour-and-travel .callout h3{width:480px;max-width:100%}", ""]);
// Exports
module.exports = exports;
